import { render, staticRenderFns } from "./ViewSelector.vue?vue&type=template&id=4b9217b0&scoped=true"
import script from "./ViewSelector.vue?vue&type=script&lang=js"
export * from "./ViewSelector.vue?vue&type=script&lang=js"
import style0 from "./ViewSelector.vue?vue&type=style&index=0&id=4b9217b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9217b0",
  null
  
)

export default component.exports